@if (deviceService.isNativePlatform) {
    <div class="top-safezone-offset" [style.height]="nativeSafeZoneService.paddings.top + 'px'"></div>
}
@if (viewNeedUpdateOverlay()) {
    <div class="phone-overlay need-update-overlay">
        <svg-icon src="assets/icons/arrows-spin.svg"
            [svgStyle]="{ 'width.px':34, 'height.px':34}"
        ></svg-icon>
        <h2>{{ 'overlay.update.title' | translate }}</h2>
        <p>{{ 'overlay.update.text1' | translate }}</p>
        <p>{{ 'overlay.update.text2' | translate }}</p>

        <button class="update-btn" (click)="goToAppStore()">
            {{ 'overlay.update.button' | translate }}
        </button>
    </div>
} @else {
    @if (phoneNativeService.biometryLocked()) {
        <div class="phone-overlay biometry-locked-overlay">
            <!-- todo: dark mode -->
            <svg-icon src="assets/img/logo/bwm-logo.svg" [svgStyle]="{ 'width.px':152, 'height.px':48 }"></svg-icon>
        </div>
    }
    <router-outlet></router-outlet>
}